import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';

import { gettext } from 'utils/text';
import RadioButton from 'components/RadioButton';
import { setFilterKey } from 'ducks/newslist';

const renderHelmet = (title) => {
    const pageTitle = gettext('Trafo.no, the largest society for young artists in the north');
    return (
        <Helmet>
            <title>{`${gettext('News')} — ${title} — ${pageTitle}`}</title>
        </Helmet>
    );
};

const NewsListFilter = ({ choices, onChange, selectedFilterKey, setTitle, noFlex }) => (
    <div className={classNames('arena__filter', { 'arena__filter--noflex': noFlex })}>
        {setTitle ? renderHelmet(choices.find((filter) => filter.key === selectedFilterKey).label) : null}
        {choices.map((filter) => (
            <RadioButton
                key={filter.key}
                name="filter"
                value={filter.key}
                id={filter.key}
                label={filter.label}
                onChange={onChange}
                checked={selectedFilterKey === filter.key}
            />
        ))}
    </div>
);

NewsListFilter.propTypes = {
    choices: PropTypes.array.isRequired, // eslint-disable-line
    onChange: PropTypes.func.isRequired,
    selectedFilterKey: PropTypes.string.isRequired,
    setTitle: PropTypes.bool.isRequired,
    noFlex: PropTypes.bool,
};

NewsListFilter.defaultProps = {
    noFlex: false,
};

const mapStateToProps = (state) => ({
    selectedFilterKey: state.filterKey,
    choices: state.choices,
});

const mapDispatchToProps = (dispatch) => ({
    onChange: (e) => dispatch(setFilterKey(e.target.value)),
});

const NewsListFilterConnected = connect(mapStateToProps, mapDispatchToProps)(NewsListFilter);

export default NewsListFilterConnected;



// WEBPACK FOOTER //
// ./src/components/news/NewsListFilter.js